// Import conflict prevention utilities first
import './utils/disableConflicts';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.jsx';

// Wrap the entire application in a try-catch to prevent crashes
try {
  console.log('Initializing Stanley D Karaoke application...');
  
  // Use the new root element ID
  const rootElement = document.getElementById('stanley-karaoke-root');

  // Ensure the element exists before rendering
  if (rootElement) {
    const root = createRoot(rootElement);
    
    // Use a controlled render process
    setTimeout(() => {
      try {
        console.log('Rendering application...');
        root.render(
          <StrictMode>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </StrictMode>
        );
        console.log('Application rendered successfully!');
      } catch (renderError) {
        console.error('Error rendering application:', renderError);
        // Show a fallback UI in case of render errors
        rootElement.innerHTML = `
          <div style="padding: 20px; text-align: center;">
            <h2>Application Error</h2>
            <p>Sorry, the application failed to load. Please try refreshing the page.</p>
            <p>Error: ${renderError.message}</p>
            <button onclick="window.location.reload()">Refresh Page</button>
          </div>
        `;
      }
    }, 100); // Small delay to ensure DOM is ready
  } else {
    console.error('Root element not found! Make sure the HTML contains an element with id="stanley-karaoke-root"');
    document.body.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h2>Application Error</h2>
        <p>Root element not found. Please check your HTML structure.</p>
        <button onclick="window.location.reload()">Refresh Page</button>
      </div>
    `;
  }
} catch (error) {
  console.error('Fatal application error:', error);
  // Provide a fallback UI for catastrophic errors
  document.body.innerHTML = `
    <div style="padding: 20px; text-align: center;">
      <h2>Application Error</h2>
      <p>A fatal error occurred while initializing the application.</p>
      <p>Error: ${error.message}</p>
      <button onclick="window.location.reload()">Refresh Page</button>
    </div>
  `;
}
